import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription } from 'rxjs';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import * as HelpActions from 'src/app/store/help/help.actions';
import { selectSubSectionCurrent, selectSubsectionModify } from 'src/app/store/help/help.selector';
import { SubSectionDataDb } from 'src/app/model/help';
import { StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { HelperSectionDialogComponent } from '../helper-section-dialog/helper-section.dialog.component';

@Component({
	templateUrl: './helper-subsection.dialog.component.html',
})

export class HelperSubSectionDialogComponent implements OnInit, OnDestroy {

	subsectionModifySuccess$: Observable<boolean | undefined>;
	subsectionModifySuccessSub: Subscription | undefined;
	subSectionCurrent$: Observable<SubSectionDataDb | undefined>;
	subSectionCurrentSub: Subscription | undefined;

	subSectionForm: FormGroup;
	subsection: SubSectionDataDb;
	adding = true;

	sectionId: number;
	KeyHelp: string;

	flagImagePath = './assets/images/flags/';
	flagImageFormat = '.svg';

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.initSelectors();
		this.store.dispatch(HelpActions.resetSubSectionForm());
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
		if (this.config.data !== undefined && this.config.data.sectionId !== undefined) {
			this.sectionId = this.config.data.sectionId;
		}
		if (this.config.data !== undefined && this.config.data.subsectionId !== undefined) {
			this.store.dispatch(HelpActions.getHelpSubSection({ subsectionId: this.config.data.subsectionId }));
			this.adding = false;
		} else {
			this.subsection = new SubSectionDataDb();
			this.adding = true;

		}
		this.buildForm();
		StandardNewValidator.setFirstCompile(true);
	}

	buildForm(): void {
		this.subSectionForm = new FormGroup({
			'KeyHelp': new FormControl(this.subsection !== undefined ? this.subsection.KeyHelp : '', Validators.required),
			'TitleIt': new FormControl(this.subsection !== undefined ? this.subsection.TitleIt : '', Validators.required),
			'TitleEn': new FormControl(this.subsection !== undefined ? this.subsection.TitleEn : ''),
			'TitleEs': new FormControl(this.subsection !== undefined ? this.subsection.TitleEs : ''),
			'TitleDe': new FormControl(this.subsection !== undefined ? this.subsection.TitleDe : ''),
			'TitleFr': new FormControl(this.subsection !== undefined ? this.subsection.TitleFr : ''),
			'TitleNl': new FormControl(this.subsection !== undefined ? this.subsection.TitleNl : ''),
			'TitlePl': new FormControl(this.subsection !== undefined ? this.subsection.TitlePl : ''),
			'TitleRu': new FormControl(this.subsection !== undefined ? this.subsection.TitleRu : ''),
			'TitleSk': new FormControl(this.subsection !== undefined ? this.subsection.TitleSk : ''),
			'TitleHu': new FormControl(this.subsection !== undefined ? this.subsection.TitleHu : ''),
			'TitlePt': new FormControl(this.subsection !== undefined ? this.subsection.TitlePt : ''),
			'TitleSv': new FormControl(this.subsection !== undefined ? this.subsection.TitleSv : ''),
			'TitleCs': new FormControl(this.subsection !== undefined ? this.subsection.TitleCs : ''),
			'User': new FormControl({ value: this.subsection !== undefined ? this.subsection.User === 1 : false, disabled: false }),
			'Technician': new FormControl({ value: this.subsection !== undefined ? this.subsection.Technician === 1 : false, disabled: false }),
			'Service': new FormControl({ value: this.subsection !== undefined ? this.subsection.Service === 1 : false, disabled: false }),
			'Guest': new FormControl({ value: this.subsection !== undefined ? this.subsection.Guest === 1 : false, disabled: false }),
			'Thermo': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.thermosg') : false, disabled: false }),
			'SetUp': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.crpconnectapp') : false, disabled: false }),
			'Automation': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.cameconnectapp') : false, disabled: false }),
			'Access': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.myaccess') : false, disabled: false }),
			'SetUpPro': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.installer') : false, disabled: false }),
			'Web': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('frontend') : false, disabled: false }),
			'IntercomSetup': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('intercomsetup') : false, disabled: false }),
		});
	}

	initSelectors(): void {
		this.subsectionModifySuccess$ = this.store.select(selectSubsectionModify);
		this.subSectionCurrent$ = this.store.select(selectSubSectionCurrent);
	}

	subscribeAll(): void {
		this.subsectionModifySuccessSub = this.subsectionModifySuccess$?.subscribe(
			(subsectionModifySuccess) => {
				if (subsectionModifySuccess) {
					this.ref.close('success');
				}
			}
		);
		this.subSectionCurrentSub = this.subSectionCurrent$.subscribe((subsectionCurrent) => {
			if (subsectionCurrent !== undefined) {
				this.subSectionCurrentSub?.unsubscribe();
				this.subsection = subsectionCurrent;
				this.buildForm();
				if (!this.adding && this.subsection.DestinationClients.includes('intercomsetup')) {
					this.subSectionForm.controls['Guest'].setValue(true);
					this.subSectionForm.controls['Guest'].disable();
				}
			}
		});
	}

	ngOnDestroy(): void {
		this.subsectionModifySuccessSub?.unsubscribe();
	}

	isRowText(): boolean {
		return this.f.ContentType.value === 'text';
	}

	isRowVideo(): boolean {
		return this.f.ContentType.value === 'video';
	}

	onSelectedIntercomSetup(): void {
		const intercomSetupFlag : boolean = this.subSectionForm.get("IntercomSetup").value;
		if (intercomSetupFlag) {
			this.subSectionForm.controls['Thermo'].setValue(false);
			this.subSectionForm.controls['SetUp'].setValue(false);
			this.subSectionForm.controls['Automation'].setValue(false);
			this.subSectionForm.controls['Access'].setValue(false);
			this.subSectionForm.controls['SetUpPro'].setValue(false);
			this.subSectionForm.controls['Web'].setValue(false);

			this.subSectionForm.controls['User'].setValue(false);
			this.subSectionForm.controls['Technician'].setValue(false);
			this.subSectionForm.controls['Service'].setValue(false);
			this.subSectionForm.controls['Guest'].setValue(true);
			this.subSectionForm.controls['Guest'].disable();
		} else {
			this.subSectionForm.controls['Guest'].enable();
			this.subSectionForm.controls['Guest'].setValue(false);
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.subSectionForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.subSectionForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	getFlagImage(langCode: string): string {
		return this.flagImagePath + langCode + this.flagImageFormat;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}
	
	save(): void {
		if (this.sectionId === undefined) {
			this.sectionId = this.subsection.SectionId;
		}
		let destinationsClients = '';
		if (this.f.Thermo.value) {
			destinationsClients = destinationsClients + 'com.came.thermosg';
		}
		if (this.f.SetUp.value) {
			if (destinationsClients !== '') {
				destinationsClients = destinationsClients + ', ';
			}
			destinationsClients = destinationsClients + 'com.came.crpconnectapp';
		}
		if (this.f.SetUpPro.value) {
			if (destinationsClients !== '') {
				destinationsClients = destinationsClients + ', ';
			}
			destinationsClients = destinationsClients + 'com.came.installer';
		}
		if (this.f.Automation.value) {
			if (destinationsClients !== '') {
				destinationsClients = destinationsClients + ', ';
			}
			destinationsClients = destinationsClients + 'com.came.cameconnectapp';
		}
		if (this.f.Access.value) {
			if (destinationsClients !== '') {
				destinationsClients = destinationsClients + ', ';
			}
			destinationsClients = destinationsClients + 'com.came.myaccess';
		}
		if (this.f.Web.value) {
			if (destinationsClients !== '') {
				destinationsClients = destinationsClients + ', ';
			}
			destinationsClients = destinationsClients + 'frontend';
		}
		if (this.f.IntercomSetup.value) {
			if (destinationsClients !== '') {
				destinationsClients = destinationsClients + ', ';
			}
			destinationsClients = destinationsClients + 'intercomsetup';
		}
		this.subsection = {
			...this.subsection,
			SectionId: this.sectionId,
			KeyHelp: this.f.KeyHelp.value,
			TitleIt: this.f.TitleIt.value,
			TitleEn: this.f.TitleEn.value,
			TitleEs: this.f.TitleEs.value,
			TitleDe: this.f.TitleDe.value,
			TitleFr: this.f.TitleFr.value,
			TitleNl: this.f.TitleNl.value,
			TitlePl: this.f.TitlePl.value,
			TitleRu: this.f.TitleRu.value,
			TitleSk: this.f.TitleSk.value,
			TitleHu: this.f.TitleHu.value,
			TitlePt: this.f.TitlePt.value,
			TitleSv: this.f.TitleSv.value,
			TitleCs: this.f.TitleCs.value,
			User: this.f.User.value ? 1 : 0,
			Technician: this.f.Technician.value ? 1 : 0,
			Service: this.f.Service.value ? 1 : 0,
			Guest: this.f.Guest.value ? 1 : 0,
			DestinationClients: destinationsClients,
		};
		if (this.subsection.Id) {
			this.store.dispatch(HelpActions.editHelpSubSection({ subsection: this.subsection }));
		} else {
			this.store.dispatch(HelpActions.addHelpSubSection({ subsection: this.subsection }));
		}
	}

	get f(): any {
		return this.subSectionForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: HelperSectionDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	newShowErrors(type: HelperSectionDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}
}
